export default {"src":"/_next/static/media/uber-logo.daa5b8a0.svg","height":52,"width":156,"blurWidth":0,"blurHeight":0};